import React from 'react'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import { useHistory, useParams } from 'react-router-dom'
import { Icon } from '@naturacosmeticos/natds-react'
import { getGlobalAccountUrl } from '../../../../services/config'
import Button from '../../../../components/Buttons/Button'
import useStyles from './EditButton.styles'
import { useResponsiveness } from '../../../../hooks/responsive'
import { companyNameById } from '../../../../models/company-name-by-id'
import { useTenantConfigs } from '../../../../hooks/useTenantConfigs'
import { validateDesignEloIsActive } from '../../../../utils/validateCountryId'
import { validCountryIds } from '../../../../models/country-id'

const validCountries = validCountryIds.map((countryId) => countryId.toLowerCase())

const getValidCountry = () => {
  const country = localStorage.getItem('country')?.toLocaleLowerCase()
  if (country && validCountries.includes(country)) {
    return country
  }
  console.warn('Invalid country in localStorage, using default "br"')
  return 'br'
}

const getValidCompany = () => {
  const company = companyNameById[Number(localStorage.getItem('company'))]?.toLocaleLowerCase()
  if (company) {
    return company
  }
  console.warn('Invalid company in localStorage, using default "natura"')
  return 'natura'
}

const EditButton = ({ personId, display }) => {
  const classes = useStyles({ display })
  const { id, status } = useParams()
  const { isDesktop } = useResponsiveness()
  const globalExternalService = getGlobalAccountUrl()
  const getFormPath = () => {
    const safeCountry = encodeURIComponent(getValidCountry())
    const safeCompany = encodeURIComponent(getValidCompany())
    const safePersonId = encodeURIComponent(personId || '')
    return `sso?country=${safeCountry}&company=${safeCompany}&editPersonId=${safePersonId}`
  }
  const { configs } = useTenantConfigs()
  const history = useHistory()
  const isElo = validateDesignEloIsActive()

  const FormatedButton = ({ onClick }) => (
    <Button
      variant="contained"
      color="primary"
      className={isDesktop ? classes.editButton : classes.editButtonMobile}
      id="edit-person"
      size="medium"
      onClick={onClick}
      startIcon={isElo && <Icon name="outlined-action-edit" />}
      display={display}
    >
      <FormattedMessage id="edit" defaultMessage="Edit" />
    </Button>
  )

  if (configs?.profile.editContactWithV3) {
    return <FormatedButton onClick={() => history.push(`/${status}/edit/${id}`)} />
  }

  return (
    <a
      className={classes.anchor}
      href={new URL(getFormPath(), globalExternalService.url).href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="edit button"
    >
      <FormatedButton />
    </a>
  )
}

EditButton.propTypes = {
  personId: PropTypes.string.isRequired,
}

export default EditButton
